import(/* webpackMode: "eager" */ "/app/apps/ashtrom-melet/app/[locale]/not-found.tsx");
